<template>
	<div class="w-100">
		<div class="row row-hubs pt-5 pb-5 position-relative">
			<div class="row-grid" id="scroller">
				<div class="col-first-hub">
					<div class="zoom-img-container" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/coffret-cadeau-hortense-2.webp" alt="CARTE CADEAU" class="zoom-img">
					</div>
				</div>
				<div class="col-hub">
					<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/carte-cadeau.webp" alt="CARTE CADEAU" class="zoom-img">
					</div>
					<p class="merriweather-bold-p16 pt-3 w-100 mb-2">CARTE CADEAU</p>
					<p class="raleway-reg-p15">D’un montant libre entre <span class="raleway-semi-p15">100 € et 1 000 €</span>, valable sur une sélection de lieux d’exception engagés en faveur du tourisme durable.</p>
				</div>
				<div class="col-hub">
					<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/guide-voyage.webp" alt="GUIDE DE VOYAGE" class="zoom-img">
					</div>
					<p class="merriweather-bold-p16 pt-3 w-100 mb-2">GUIDE DE VOYAGE</p>
					<p class="raleway-reg-p15">Un livre inspirant pour <span class="raleway-semi-p15">voyager autrement en France</span>, entre séjour d’exception et respect de l’environnement.</p>
				</div>
				<div class="col-hub" >
					<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/pochette-eco-friendly.webp" alt="POCHETTE ÉCO-FRIENDLY" class="zoom-img">
					</div>
					<p class="merriweather-bold-p16 pt-3 w-100 mb-2">POCHETTE ÉCO-FRIENDLY</p>
					<p class="raleway-reg-p15">Un cadeau éthique, soigneusement emballé dans une <span class="raleway-semi-p15">pochette éco-conçue</span>, aussi belle que respectueuse de l’environnement.</p>
				</div>
				<div class="col-hub" >
					<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/service-concieregerie.webp" alt="SERVICE DE CONCIERGERIE" class="zoom-img">
					</div>
					<p class="merriweather-bold-p16 pt-3 w-100 mb-2">SERVICE DE CONCIERGERIE</p>
					<p class="raleway-reg-p15">Un <span class="raleway-semi-p15">service de conciergerie</span> dédié qui organise votre séjour sur mesure.</p>
				</div>
				<div class="col-hub" >
					<div class="card-hub zoom-img-container" data-aos="fade-up" data-aos-duration="900">
						<img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/privilege-exclusif-2.webp" alt="PRIVILÈGE EXCLUSIF" class="zoom-img">
					</div>
					<p class="merriweather-bold-p16 pt-3 w-100 mb-2">PRIVILÈGE EXCLUSIF</p>
					<p class="raleway-reg-p15">Un <span class="raleway-semi-p15">service exclusif offert</span> pendant le séjour, pour sublimer chaque moment ( massage, diner, surclassement, etc.)</p>
				</div>
			</div>
			<div class="flex-shrink-0 previous-slide-button circle-icon" @click="scroll_left">
				<img src="../../images/arrow-left-black.svg" alt="Previous" />
			</div>
			<div class="flex-shrink-0 next-slide-button circle-icon" @click="scroll_right">
				<img src="../../images/arrow-right-black.svg" alt="Next" />
			</div>
		</div>
		<div class="info-container row">
			<div class="d-flex align-items-start">
				<img src="../../images/info.svg" v-set-alt/>
				<p class="raleway-reg-p15 mb-0" :class="isPhone ? 'ml-2' : 'ml-3'">La carte cadeau est imprimée sur un papier ensemencé 100% biodégradable.<br> Le guide de voyage de 400 pages vous invite à découvrir la France à travers le prisme du tourisme durable et responsable.</p>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'giftExperience',
		data() {
			return {
				isPhone: window.innerWidth <= 768,
			}
		},
		methods: {
			goToGroup(url){
				window.open(url, '_blank');
			},
			scroll_left() {
				let content = document.querySelector("#scroller");
				content.scrollLeft -= 220;
			},
			scroll_right() {
				let content = document.querySelector("#scroller");
				content.scrollLeft += 220;
			}
		}
	};
</script>
<style scoped lang="scss">
.row-hubs {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 1rem;

	@media screen and (max-width: 767px) {
		padding-left: 3%;
		padding-right: 3%;
	}
}

.row-grid {
	display: flex;
	gap: 25px;
	overflow-x: auto;
	justify-content: start;

	@media screen and (max-width: 767px) {
		gap: 12px;
	}
}

.col-first-hub {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
}

.col-first-hub img.zoom-img {
	height: 100%;
	width: auto;
	object-fit: fill;
}

.col-hub {
	flex: 0 0 18%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.card-hub {
	position: relative;
	width: 100%;
	height: 352px;
	max-height: 500px;
}

.card-hub img {
	width: 100%;
	height: 352px;
	object-fit: cover;

	@media screen and (max-width: 767px) {
		width: 282px;
		height: 352px;
	}
}

.card-hub p {
	align-items: start;
} 

.info-container {
	min-height: 110px;
	background: #A5D3AE48 0% 0% no-repeat padding-box;
	border-radius: 7px 7px 0px 7px;
	padding: 23px 37px 21px 28px;
}

#scroller {
	overflow-x: scroll !important;
}

.circle-icon {
	width: 35px;
	height: 35px;
	border: 1px solid #F5F5F5;
	background: #F5F5F5 0% 0% no-repeat padding-box;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	img {
		width: 20px;
	}
}

.previous-slide-button {
	position: absolute;
	top: 50%;
	left: -5%;
	transform: translateY(-50%);
	color: #000;

	@media screen and (max-width: 767px) {
		left: 4%;
	}
}

.next-slide-button {
	position: absolute;
	top: 50%;
	right: -5%;
	transform: translateY(-50%);
	color: #000;

	@media screen and (max-width: 767px) {
		right: 4%;
	}
}
</style>